{
  "login-page": {
    "buttons": {
      "next": "Next",
      "sign-up": "Create new account",
      "update-password": "Update password",
      "use-phone-to-login": "Login with telephone number",
      "use-email-to-login": "Login with email"
    },
    "text": {
      "title": "Login",
      "subtitle": "Login to Beauty Booking",
      "email": "Your email",
      "or": "OR",
      "password": "Password",
      "password-hint": "You need to update your password",
      "username": "Username",
      "username-hint": "You need to enter your email or telephone number"
    }
  }
}
